export default "__VITE_ASSET__B6bfWeC3__"